import { z } from 'zod';

/**
 * The shared sync response (R4), used by game events, drill attempts and Game Lab events.
 * `accepted` items carry the server sequence (SSE Last-Event-ID), `duplicates` are ids the
 * server already had, `rejected` items carry a lowercase code from errors.ts.
 */
export const MAX_EVENT_BATCH = 200;

export interface EventBatchRes<Code extends string = string> {
  accepted: { id: string; serverSeq: number }[];
  duplicates: string[];
  rejected: { id: string; code: Code }[];
  serverNow: number;
}

export function eventBatchResZ<const C extends readonly [string, ...string[]]>(codes: C) {
  return z.object({
    accepted: z.array(z.object({ id: z.string(), serverSeq: z.number().int().nonnegative() })),
    duplicates: z.array(z.string()),
    rejected: z.array(z.object({ id: z.string(), code: z.enum(codes) })),
    serverNow: z.number().int(),
  });
}

/** The outbox streams the client keeps (A9.5). Each maps to one batch endpoint. */
export const OUTBOX_STREAM_KINDS = ['game', 'drill', 'lab'] as const;
export type OutboxStreamKind = (typeof OUTBOX_STREAM_KINDS)[number];
